import {
  NATIVE_PUSH_TOKEN_REQUEST_TYPE,
  NATIVE_PUSH_TOKEN_RESPONSE_TYPES,
  PUSH_DEVICE_STORAGE_KEY,
} from './pushConstants';

function parseJsonSafely(rawValue) {
  if (typeof rawValue !== 'string') {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    return null;
  }
}

function normalizePushDevice(rawPayload) {
  if (!rawPayload) {
    return null;
  }

  if (typeof rawPayload === 'string') {
    const parsedPayload = parseJsonSafely(rawPayload);
    if (parsedPayload) {
      return normalizePushDevice(parsedPayload);
    }
    return null;
  }

  if (typeof rawPayload !== 'object') {
    return null;
  }

  const payloadType = String(rawPayload.type || '').trim();
  const hasKnownType =
    !payloadType || NATIVE_PUSH_TOKEN_RESPONSE_TYPES.includes(payloadType);
  const token = String(rawPayload.token || rawPayload.fcmToken || '').trim();

  if (!hasKnownType || !token) {
    return null;
  }

  return {
    token,
    platform: String(rawPayload.platform || 'unknown').trim().toLowerCase(),
  };
}

export function isReactNativeWebViewAvailable() {
  return Boolean(
    window.ReactNativeWebView &&
      typeof window.ReactNativeWebView.postMessage === 'function',
  );
}

export function requestNativePushToken() {
  if (!isReactNativeWebViewAvailable()) {
    return false;
  }

  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      type: NATIVE_PUSH_TOKEN_REQUEST_TYPE,
    }),
  );
  return true;
}

export function loadStoredPushDevice() {
  const rawValue = localStorage.getItem(PUSH_DEVICE_STORAGE_KEY);
  const parsed = parseJsonSafely(rawValue);
  return normalizePushDevice(parsed);
}

export function saveStoredPushDevice(pushDevice) {
  if (!pushDevice?.token) {
    return;
  }
  localStorage.setItem(PUSH_DEVICE_STORAGE_KEY, JSON.stringify(pushDevice));
}

export function clearStoredPushDevice() {
  localStorage.removeItem(PUSH_DEVICE_STORAGE_KEY);
}

export function subscribeNativePushToken(listener) {
  if (typeof listener !== 'function') {
    return () => {};
  }

  const handleMessage = (event) => {
    const pushDevice = normalizePushDevice(event?.data);
    if (!pushDevice) {
      return;
    }
    saveStoredPushDevice(pushDevice);
    listener(pushDevice);
  };

  window.addEventListener('message', handleMessage);
  document.addEventListener('message', handleMessage);

  return () => {
    window.removeEventListener('message', handleMessage);
    document.removeEventListener('message', handleMessage);
  };
}
